import { useEffect } from 'react';

import moment from 'moment';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import toast from 'react-hot-toast';
import { LinkedinShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';

import LeftIcon from '@/assets/icons/icon-arrow-left.svg';
import FacebookIcon from '@/assets/icons/icon-facebook.svg';
import LinkedinIcon from '@/assets/icons/icon-linkedin.svg';
import ShareIcon from '@/assets/icons/icon-share.svg';
import TwitterIcon from '@/assets/icons/twitter-icon.svg';
import { useAppSelector } from '@/hooks/redux';
import useAuthenticate from '@/hooks/useAuthenticate';
import { INettyNews } from '@/redux/news/model';
import { formatImgUrl } from '@/utils/formatter';
import { cn } from '@/utils/helper';

import { Loader } from '../../Loader';

interface INewsDetail {
  detail: INettyNews;
}

const NewsDetail = ({ detail }: INewsDetail) => {
  const router = useRouter();
  const { slug } = router.query;
  const { detailLoading } = useAppSelector((state) => state.news);
  const { isAuth } = useAuthenticate();

  const link = typeof window !== 'undefined' ? window.location.origin + window.location.pathname : '';
  useEffect(() => {}, [slug]);

  const copyHandler = (url: string) => {
    navigator?.clipboard?.writeText(url);
    toast.success('copied');
  };

  return (
    <div className='pb-[200px] lg:pb-0'>
      {detailLoading ? (
        <div className='flex justify-center'>
          <Loader />
        </div>
      ) : (
        <div>
          <Link href='/crypto-news' className={cn('flex bg-white dark:!bg-jet-black dark:border-b dark:border-midnight-gray gap-[11px] pl-7 pt-[30px] pb-5 cursor-pointer items-center border-b lg:sticky z-20 top-0', isAuth ? 'top-0 ml-[1px]' : 'top-[97px]')}>
            <LeftIcon className='fill-primary' />
            <span className='text-[22px] font-semibold'>Netty News</span>
          </Link>
          <div className='pt-7 px-5 lg:pl-[53px] lg:pr-[50px] lg:pb-[95px]'>
            <div className='w-full relative overflow-hidden h-[301px] rounded'>
              <Image priority fill src={formatImgUrl(detail?.featured_image_src)} alt={detail?.title.rendered} className='object-cover' />
            </div>
            <div className='mt-[18px] flex items-center justify-between'>
              <div className='flex items-center justify-center gap-[17px]'>
                <p className='text-base/none font-normal'>By : {detail.author_info.display_name}</p>
                <div className='flex justify-center items-center gap-1'>
                  <p className='text-base/none font-normal pt-[1px]'>{moment(detail?.date).format('MMM D,YYYY')}</p>
                </div>
              </div>
              <div className='flex items-center justify-center gap-5'>
                <TwitterShareButton url={link} title={detail?.title.rendered}>
                  <TwitterIcon className='fill-primary' />
                </TwitterShareButton>
                <LinkedinShareButton url={link} title={detail?.title.rendered}>
                  <LinkedinIcon className='w-4 h-9 px-0 py-[10px] fill-primary' />
                </LinkedinShareButton>
                <FacebookShareButton url={link} title={detail?.title.rendered}>
                  <FacebookIcon className='w-4 h-9 px-0 py-[10px] fill-primary' />
                </FacebookShareButton>
                <button onClick={() => copyHandler(link)}>
                  <ShareIcon className='fill-primary' />
                </button>
              </div>
            </div>
            <h1 className='text-coal-250 text-2xl sm:text-4xl/[47px] font-bold mt-8'>{detail.title.rendered}</h1>
            <div className='w-full'>
              <div className='flex flex-col gap-10 news_detail'>
                <div
                  dangerouslySetInnerHTML={{
                    __html: detail?.content.rendered,
                  }}
                  className='news_article'
                ></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsDetail;
